/* global CLOUDINARY_SHARE */
import React, { PureComponent } from 'react'
import SwapImage from '../SwapImage'
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Row,
    Col
  } from 'reactstrap'

export default class SwapPoweredImageModal extends PureComponent {
  static defaultProps = {
    itemID: false,
    onConfirm: () => {},
    onCancel: () => {},
    headerLabel: 'Swap Powered image...',
    confirmBtnLabel: 'Swap',
    cancelBtnLabel: 'Cancel',
    confirmBtnClass: 'btn btn-primary',
    cancelBtnClass: 'btn btn-default',
    showCancel: true,
    submittingLabel: (
      <span>
        Swapping... <i className="fa fa-cog fa-spin" />
      </span>
    ),
  }

  constructor(props) {
    super(props)
    this.state = {
      isSubmitting: false,
      selectedImage: null,
      hasErrors: false
    }
    this.onImageClick = this.onImageClick.bind(this)
    this.onSwap = this.onSwap.bind(this)
    this.renderImages = this.renderImages.bind(this)
  }

  onImageClick(imageID) {
    this.setState({selectedImage: imageID})
  }

  onSwap() {
    if(this.state.selectedImage) 
    { 
      this.setState({hasErrors: false})
      this.props.onSwap(this.props.itemID, this.state.selectedImage)
    }
    else this.setState({hasErrors: true})
  }

  renderImages() {
    const items = this.props.allImages
    const nonPoweredImages = []
    items.forEach(element => {
      if (!element.poweredId) {
        nonPoweredImages.push(element)
      }  
    })
    return nonPoweredImages.map(image => (
      <SwapImage
        onImageClick={this.onImageClick}
        key={image.id}
        image={image}
        currentSelected={this.state.selectedImage}
      />
    ))
  }

  render() {
    const submitDisabled = this.props.buttonsDisabled
    const submitLabel = this.props.buttonsDisabled
      ? this.props.submittingLabel
      : this.props.confirmBtnLabel

    return (
        <Modal
            isOpen={this.props.open}
            toggle={this.toggle}
            className={this.props.className}
            //contentClassName="custom-modal-style"
        >
            <ModalHeader toggle={this.props.onClose}>{this.props.headerLabel}</ModalHeader>
            <ModalBody>
                {this.state.hasErrors && !this.state.selectedImage && <div className="power-input-error">Please select an image to swap.</div>}
                <Row>
                    <Col>
                        <div className="album-grid">
                            {this.renderImages()}
                        </div>
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
            <Button
                color="secondary"
                onClick={this.props.onClose}
                disabled={submitDisabled}
            >
                {this.props.cancelBtnLabel}
            </Button>
            <Button
                color="primary"
                onClick={this.onSwap}
                disabled={submitDisabled}
            >
                {submitLabel}
            </Button>
            </ModalFooter>
        </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Components/Modals/SwapPoweredImageModal.js